exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#partI[data-v-5bf1fdc2]{height:70vh}#part2[data-v-5bf1fdc2]{height:30vh}.vertical-center[data-v-5bf1fdc2]{display:flex;align-items:center;justify-content:center}.shortedit[data-v-5bf1fdc2]{position:absolute}.dashfav[data-v-5bf1fdc2]{max-height:248px;overflow-y:auto}.iconfav[data-v-5bf1fdc2]{width:20px}", ""]);

// exports
